import React, { Component } from 'react';
import Footer from '../Footer/Footer';
import PhotoSlider from './PhotoSlider';
import Loading from './Loading';
import { Link } from 'react-router-dom'
import { client } from '../utils/contentful.js'
import { applyPageBackground } from '../utils/utils.js'
import {
  CSSTransitionGroup
} from 'react-transition-group';


class Photo extends Component {
  state = {
    viewType: 'scroll',
    viewText: 'grid',
    personalPosts: [],
    loading: true,
    winWidth: window.innerWidth
  }

  componentDidMount() {
    client.getEntries({
      content_type: 'elsewhere'
    })
      .then((res) => {
        if (!res.items || !res.items[0] || !res.items[0].fields.posts) return;
        this.setState({ personalPosts: res.items[0].fields.posts });
      })
      .catch((err) => {
        console.error('Photo journal fetch failed', err);
      });

    window.addEventListener('resize', this.setWidth)
    document.querySelector('body').classList.remove("fix-background");
    applyPageBackground('#fff');
    this.removeLoader();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setWidth);
  }

  setWidth = () => {
    this.setState({
      winWidth: window.innerWidth
    })
  }

  removeLoader = () => {
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 200)
  }

  changeView = () => {
    if (this.state.viewType === "scroll") {
      this.setState({ viewType: "grid", viewText: 'scroll' })
    } else {
      this.setState({ viewType: "scroll", viewText: 'grid' })
    }
  }


  render() {
    let photoContent = this.state.personalPosts.map((item, index) => {
      let isStart = " ";
      index < 2 ? isStart = "on__screen" : isStart = "";
      return <PhotoSlider key={index} isStart={isStart} viewType={this.state.viewType} postContent={item} />
    }
    )
    return (
      <div className={`App photo ${this.state.viewType}`}>
        <div className="spacer"></div>
        <div className="view__type desktop" onClick={this.changeView}>
          {this.state.viewText} &middot; journal
        </div>
        <div className="view__type mobile">
          journal
        </div>
        <div className="spacer__small"></div>
        <main>
          {this.state.loading && this.state.winWidth < 768 &&
            <Loading />
          }
          <CSSTransitionGroup
            transitionName="example"
            transitionAppear={true}
            transitionEnterTimeout={0}
            transitionAppearTimeout={0}
            transitionEnter={true}
            transitionLeaveTimeout={0}>
            {this.state.personalPosts.length >= 0 ? photoContent : ""}
          </CSSTransitionGroup>
        </main>
        <div className="spacer"></div>
        <Link className="return__home" to="/" style={{ fontFamily: 'newFont, Sackers, sans-serf' }}>{this.props.footerText}</Link>
        <Footer />
      </div>
    );
  }
}

export default Photo;
